module.exports = __webpack_public_path__ + "img/Lorinthe-Logo.7ef5954b.png";